import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { map } from 'rxjs/operators';

export const noAuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isAuthenticated().pipe(
    map((isAuthenticated) => {
      if (isAuthenticated) {
        const path = route.routeConfig?.path ?? '';

        // Redirect to appropriate thank you page based on the route
        if (path === '' || path === 'wizard/v1/landing' || path === 'wizard/v2/landing') {
          router.navigate(['/dashboard']);
        }

        return false;
      }

      return true;
    }),
  );
};
